module.exports = __webpack_public_path__ + "static/media/notification-bell.23beec9a.svg";